import { Tooltip } from "@mantine/core"

interface TooltipLabelProps {
  tip?: string
  children: React.ReactNode
}

function TooltipLabel(props: TooltipLabelProps) {
  if (!props.tip) return <>{props.children}</>

  return (
    <div className="flex items-center gap-1.5">
      {props.children}
      <Tooltip label={props.tip} withArrow arrowSize={8} arrowOffset={20} multiline className="text-center" position="top-start">
        <IconMaterialSymbolsHelpOutline className="size-[17px] text-fg-quarternary" />
      </Tooltip>
    </div>
  )
}

export default TooltipLabel
